export default "<div class=\"progress_bar_wrapper\">\n  <div class=\"progress_bar_progress\"></div>\n</div>\n";